export function addCssAnchorName(element: HTMLElement, anchorName: string) {
  const names = readCssAnchorNames(element)
  writeCssAnchorNames(element, [...names, anchorName])
  return () => {
    writeCssAnchorNames(
      element,
      readCssAnchorNames(element).filter((name) => name !== anchorName),
    )
  }
}

function readCssAnchorNames(element: HTMLElement) {
  return element.style
    .getPropertyValue('anchor-name')
    .split(',')
    .map((name) => name.trim())
    .filter(Boolean)
}

function writeCssAnchorNames(element: HTMLElement, names: string[]) {
  if (names.length === 0) element.style.removeProperty('anchor-name')
  else element.style.setProperty('anchor-name', [...new Set(names)].join(', '))
}
